import classnames from 'classnames'

import Checkbox from '@components/Checkbox'
import ValidationError from '@components/ValidationError'

import './styles.scss'

const TermsAndConditionsCheckbox = ({ name = 'acceptTerms', checked, onChange, error, className, children }) => (
    <div className={classnames('terms-checkbox', className)}>
        <Checkbox
            name={name}
            checked={!!checked}
            onChange={onChange}
            aria-invalid={Boolean(error)}
            className={classnames('terms-checkbox__control', {
                'terms-checkbox__control--error': Boolean(error),
            })}>
            {children}
        </Checkbox>
        <ValidationError>{error}</ValidationError>
    </div>
)

export default TermsAndConditionsCheckbox
